import { useScroll } from 'framer-motion';
import { useState, useEffect } from 'react';

// ----------------------------------------------------------------------

type ReturnType = boolean;

interface UseScrollOptions extends Omit<ScrollOptions, 'container' | 'target'> {
  container?: React.RefObject<HTMLElement>;
  target?: React.RefObject<HTMLElement>;
}

export default function useOffSetTop(topInRem = 6.25, options?: UseScrollOptions): ReturnType {
  const { scrollY } = useScroll(options);
  const [value, setValue] = useState(false);

  // Function to convert rem to pixels
  const remToPixels = (rem: number) => {
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    return rem * rootFontSize;
  };

  const top = remToPixels(topInRem);

  useEffect(() => {
    const unsubscribe = scrollY.on('change', (scrollHeight) => {
      if (scrollHeight > top) {
        setValue(true);
      } else {
        setValue(false);
      }
    });

    return () => {
      unsubscribe();
    };
  }, [scrollY, top]);

  return value;
}
// Usage
// const offset = useOffSetTop(100);

// Or
// const offset = useOffSetTop(100, {
//   container: ref,
// });
